import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash';

@Injectable({ providedIn: 'root' })
export class RelatedPartyInsertCategoryService {

  constructor(private http: HttpClient) { }

  saveCategoryInsert(
    baseUrl: string,
    clob_settings: any[],
    globalParams: any,
    filterParams: any = {},
    userSettings: any = {}
  ): Observable<any> {
    let params: any = _.merge({}, globalParams, filterParams);

    const jsonObj = JSON.stringify(clob_settings);
    const jsonSettings = JSON.stringify(clob_settings);

    params.jsonObj = jsonObj;
    params.jsonSettings = jsonSettings;
    params.process_name = 'INSERT_CATEGORY_DATA';
    params.sso_id = userSettings?.user?.sso_id || '';

    params.tax_year = filterParams.tax_year || params.tax_year || globalParams.tax_year;
    params.scenario = filterParams.scenario || params.scenario || globalParams.scenario;
    params.jcd_key = filterParams.jcd_key || params.jcd_key || globalParams.jcd_key || 250;
    params.scenarioCode = filterParams.scenarioCode || filterParams.scenario_code || params.scenarioCode || 'RAF';
    params.is_issue_key_enabled = 'N';

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    const url = `${baseUrl}/saveJsonObject?action_code=ybb4n2`;

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
